module.exports = __webpack_public_path__ + "static/goggles_of_night-eb39dc1dc8cbea3e0516e9d04ad230b4.jpeg";